import { Navigate, RouteObject } from 'react-router-dom';

import { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { isSearchType } from 'modules/search/helpers/isSearchType';
import { SearchAllPageLoadable } from 'modules/search/pages/All/SearchAllPageLoadable';
import { SearchType } from 'modules/search/types/SearchType';
import { routeElementWithLoader } from 'routing/utils/routeElementWithLoader';

import { searchGetAllRoutePath } from './helpers/searchGetAllRoutePath';
import { searchGetRoutePathSwitch } from './helpers/searchGetRoutePathSwitch';

const urlByLocale = {
  en: searchGetAllRoutePath({ lang: 'en' }),
  es: searchGetAllRoutePath({ lang: 'es' }),
  pt: searchGetAllRoutePath({ lang: 'pt' }),
} as const satisfies Record<UserLocale, string>;

export const searchAllRouteObjects = (['en', 'es', 'pt'] as const).map(
  (locale) => ({
    path: urlByLocale[locale],
    ...routeElementWithLoader({
      loader: async ({ request }) => {
        const { searchParams } = new URL(request.url);
        const listingTypeQueryParam = searchParams.get('listing-type');

        if (listingTypeQueryParam && isSearchType(listingTypeQueryParam)) {
          return {
            type: 'REDIRECT_FROM_ALL',
            query: searchParams.get('q') || undefined,
            listingType: listingTypeQueryParam as SearchType,
          };
        }

        await SearchAllPageLoadable.load();

        return {
          type: 'SEARCH',
          handle: {
            urlByLocale,
            darkBackground: true,
            defaultSearchType: 'ALL',
            hideFooterDivider: true,
            showDesktopSearch: true,
            isSearchPage: true,
          } satisfies LayoutHandleProps,
        };
      },
      render: (data) => {
        switch (data.type) {
          case 'SEARCH':
            return <SearchAllPageLoadable />;
          case 'REDIRECT_FROM_ALL':
            return (
              <Navigate
                to={searchGetRoutePathSwitch({
                  lang: CURRENT_LOCALE,
                  q: data.query,
                  filtersByName: { type: data.listingType },
                })}
              />
            );
        }
      },
    }),
  }),
) satisfies RouteObject[];
